import propTypes from 'prop-types';

const SvgDeviceMobileIcon = ({ size, color, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 66 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1.5"
        y="1.5"
        width="63"
        height="117"
        rx="9"
        stroke={color}
        strokeWidth="3"
      />
      <line
        x1="1.5"
        y1="20"
        x2="64.5"
        y2="20"
        stroke={color}
        strokeWidth="3"
      />
      <circle cx="24" cy="11" r="2.5" fill={color} />
      <circle cx="33" cy="11" r="2.5" fill={color} />
      <circle cx="42" cy="11" r="2.5" fill={color} />
      <line
        x1="1.5"
        y1="102"
        x2="64.5"
        y2="102"
        stroke={color}
        strokeWidth="3"
      />
      <rect
        x="23"
        y="108"
        width="20"
        height="4"
        rx="2"
        fill={color}
      />
    </svg>
  );
};

SvgDeviceMobileIcon.propTypes = {
  size: propTypes.oneOfType([propTypes.number, propTypes.string]),
  color: propTypes.string,
};

SvgDeviceMobileIcon.defaultProps = {
  size: 66,
  color: '#000',
};

export default SvgDeviceMobileIcon;
